import { ref, computed } from "vue";

let mobileBreakpoint = 800;
const isMobile = ref<boolean>(document.body.clientWidth < process.env.MOBILE_BREAKPOINT);
const menuOpen = ref<boolean>(false);

window.addEventListener('resize', (event) => {
    console.log(document.body.clientWidth, mobileBreakpoint);
    isMobile.value = document.body.clientWidth < mobileBreakpoint;
});

const setMobileBreakpoint = (bp: string): void =>  {
    mobileBreakpoint = parseInt(bp);
    isMobile.value = document.body.clientWidth < mobileBreakpoint;
}

export const useResponsive = () => ({
    isMobile: computed(() => isMobile.value),
    menuOpen,
    setMobileBreakpoint
})
